import { Injectable } from '@angular/core';
import { AsyncSubject } from 'rxjs/AsyncSubject';
import { LoadingController, Loading } from 'ionic-angular';

import { RcsLogin } from '../../assets/shared/rcs-login.class';
import { RcsConnectorOdooProvider } from '../../providers/rcs-connector-odoo/rcs-connector-odoo';
import { RcsConnectorIndexDbProvider } from '../rcs-connector-index-db/rcs-connector-index-db';
import { RcsSyncDataProvider } from '../rcs-sync-data-service/rcs-sync-data-service';
import { SyncProductsProvider } from '../rcs-sync-data-service/sync-products.service';

@Injectable()
export class RcsLoginProvider{

  private loading: Loading

  constructor(
    private odoo_connector: RcsConnectorOdooProvider,
    private db_service: RcsConnectorIndexDbProvider,
    private jobs_sync_service: RcsSyncDataProvider,
    private product_sync_service: SyncProductsProvider,
    private loading_controller: LoadingController,
  ) {}

  // Loggt den User ins System ein
  public login(username:string, password:string){
    let async_subject = new AsyncSubject();
    this.odoo_connector.login(username, password).subscribe(
      (data) => {
        console.log(data)
        if (data.json().result !== false){
          let login = new RcsLogin(data.json().result, username, password);
          this.db_service.add_record('login', login, 'user_login');
          this.loading = this.loading_controller.create({
            content: 'Daten werden aktualisiert'
          })
          this.loading.present();
          this.db_service.clear_collection('jobs').subscribe(
            success => {
              this.jobs_sync_service.sync_jobs(login).subscribe(
                finished => {
                  this.product_sync_service.sync_products(false);
                  this.loading.dismiss();
                  async_subject.next(true);
                  async_subject.complete();
                }
              );
            }
          );
        }else{
          async_subject.error(true);
          async_subject.complete();
        }
      })
      return async_subject;
  }

  // Überpürft der User eingeloggt ist und gibt einen Boolean im Obs zurück
  public check_login():any{
    let kd_db_service = this.db_service;
    let async_subject = new AsyncSubject();
    this.db_service.get_database_store().then(function(){
      kd_db_service.get_record_by_key('login', 'user_login').subscribe(
        (data) => {
          if (data){
            async_subject.next(true);
          }else{
            async_subject.error(true);
          }
          async_subject.complete();
        });
    })
    return async_subject;
  }

  // Loggt den User aus dem System aus
  public logout(){
    return this.db_service.delete_record('login', 'user_login');
  }
}



// WEBPACK FOOTER //
// ./src/providers/rcs-login-service/rcs-login-service.ts